<template>
  <div class="looking_site">
    <van-sticky>
      <van-nav-bar title="添加员工" left-arrow @click-left="goback()" />
    </van-sticky>
    <div class="site_form">
      <van-form
        label-width="100"
        :show-error="false"
        @submit="onSubmit"
        error-message-align="right"
      >
        <van-cell-group>
          <van-field input-align="right" label="头像" readonly>
            <template #button>
              <van-uploader
                v-model="fileList"
                :max-count="1"
                :after-read="afterRead"
                accept="image/*"
              />
            </template>
          </van-field>

          <van-field
            required
            input-align="right"
            v-model="submitData.fullName"
            label="姓名"
            placeholder="请输入姓名"
            is-link
            :rules="[{ required: true, message: '请输入姓名' }]"
          />

          <van-field
            required
            input-align="right"
            v-model="submitData.contactNumber"
            label="电话"
            placeholder="请输入联系电话"
            is-link
            :rules="[
              { required: true, message: '请输入联系电话' },
              { pattern: /^1[3456789]\d{9}$/, message: '电话格式错误！' },
            ]"
          />

          <van-field
            required
            input-align="right"
            v-model="submitData.gender_name"
            label="性别"
            placeholder="请选择性别"
            is-link
            @click="showSexsOptions = true"
            :rules="[{ required: true, message: '请选择性别' }]"
          />

          <van-field
            required
            input-align="right"
            v-model="submitData.telephone"
            label="账号"
            placeholder="请输入账号"
            is-link
            :rules="[{ required: true, message: '请输入账号' }]"
          />

          <van-field
            required
            input-align="right"
            v-model="submitData.password"
            label="密码"
            placeholder="请输入密码"
            is-link
            :rules="[{ required: true, message: '请输入密码' }]"
          >
          </van-field>
        </van-cell-group>

        <div class="form_btn">
          <van-button block color="#0CA7F0" type="info" native-type="submit"
            >保存</van-button
          >
        </div>
      </van-form>
    </div>

    <van-action-sheet
      v-model="showSexsOptions"
      :actions="sexsOptions"
      @select="onSelectType"
    />
  </div>
</template>

<script>
import { Button } from "vant";
import { NavBar } from "vant";
import { Form, Field, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { ActionSheet, Cascader, Popup, Uploader } from "vant";
import storage from "@/utils/storage";

export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      submitData: {
        id: 0,
        fullName: "", //姓名
        contactNumber: "", //电话
        gender: "", //性别
        gender_name: "",
        telephone: "", //账号
        password: "", //密码
        fileIdList: "", //头像
      },
      fileList: [],
      //性别
      showSexsOptions: false,
      sexsOptions: [],
    };
  },

  created() {
    //员工管理-性别列表
    this.employeeManagementAdd();
  },

  methods: {
    // 员工管理-性别列表
    employeeManagementAdd() {
      var that = this;
      that.$api
        .employeeManagementAddAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            var genderList = res.data.data.genderList;
            genderList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });
            that.sexsOptions = genderList;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //文件读取完回调函数
    afterRead(files) {
      var that = this;
      const fromdata = new FormData();
      fromdata.append("uploadfile", files.file);
      that.$axios
        .post(
          process.env.API_ROOT + "/tgy/mobile/attachment/uploadSingleFile",
          fromdata,
          {
            headers: {
              enctype: "multipart/form-data",
              Authorization: storage.getUserInfo(),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "上传成功",
              onClose() {
                that.submitData.fileIdList = res.data.data.id;
              },
            });
          }
          console.log(res.data);
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
      this.showCascader = false;
    },

    // 选中类型
    onSelectType(item) {
      this.submitData.gender = item.value;
      this.submitData.gender_name = item.name;
      this.showSexsOptions = false;
    },

    // 员工管理-保存
    onSubmit() {
      var that = this;
      that.$api
        .employeeManagementSaveAPI(that.submitData)
        .then(function (res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "添加成功",
              onClose() {
                that.$router.go(-1);
              },
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.looking_site {
  display: flex;
  flex-direction: column;

  .site_form {
    padding: 0px 10px;
    height: auto;

    /deep/ .van-uploader__upload {
      width: 50px;
      height: 50px;
    }

    /deep/ .van-uploader__preview-image {
      width: 50px;
      height: 50px;
    }

    /deep/ .van-cell {
      align-items: center !important;
    }

    .form_tag {
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
    }

    .van-cell {
      display: flex;
      align-items: flex-start;
    }

    .form_feature {
      color: #646566;
      margin: 15px 10px;

      .fs28::after {
        position: absolute;
        left: 110px;
        color: #ee0a24;
        margin-top: 5px;
        font-size: 7px;
        content: "*";
      }

      .van-button {
        height: 35px;
        margin-top: 15px;
        margin-right: 15px;
      }
    }
  }

  .form_btn {
    border-radius: 1000px;
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;

    .van-button {
      margin: 50px auto;
      width: 90%;
      height: 44px;
      border-radius: 4px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/place/staffAdd.vue